module.exports = __webpack_public_path__ + "img/avatar.ff174313.png";